// extracted by mini-css-extract-plugin
module.exports = {"settingClientModal":"ClientSettings_settingClientModal__Eo1SP","assignedCompanies":"ClientSettings_assignedCompanies__2Swfu"};